/**
 * sbModal.js
 *
 * Shared Ant Design Modal helpers used across the app.
 * Centralises brand styling (color, zIndex) so every confirm/warning
 * dialog looks consistent without repeating config in each hook.
 *
 * Colour comes from the theme (SB_COLORS.primary) rather than a hardcoded hex,
 * so these dialogs follow the brand — including the 2026 blue rebrand. These are
 * AntD static methods (rendered outside the tree), so they can't read the live
 * ConfigProvider theme; SB_COLORS is the shared source both paths use.
 */

import { Modal } from "antd";
import { SB_COLORS } from "theme/SbThemeV2";

const BASE_PROPS = {
  zIndex: 3300,
  wrapClassName: "sb-delete-confirm",
  okButtonProps: { style: { backgroundColor: SB_COLORS.primary, borderColor: SB_COLORS.primary } },
  cancelButtonProps: { style: { borderColor: SB_COLORS.primary, color: SB_COLORS.primary } },
};

/**
 * Branded confirm dialog — use for destructive or consent actions
 * (delete, submit, etc.).
 *
 * Returns the modal instance so callers can call `.update()` or `.destroy()`.
 */
export const showSbConfirm = (config) => Modal.confirm({ ...BASE_PROPS, ...config });

/**
 * Branded warning dialog — use for non-action informational warnings
 * shown centred on screen (e.g. "value matches current proficiency").
 */
export const showSbWarning = (config) => Modal.warning({ ...BASE_PROPS, ...config });
